import { createSlice } from "@reduxjs/toolkit";
import { UserBrand } from "types/users";
import { fetchUserBrands } from "./thunk";

export interface UserBrands {
    items: UserBrand[],
    loading: boolean,
    error: string | null,
    last_fetched_at: number|null
}

const initialState: UserBrands = {
    items: [],
    loading: false,
    error: null,
    last_fetched_at: null
}

const userBrand = createSlice({
    name: 'userBrands',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(fetchUserBrands.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(fetchUserBrands.fulfilled, (state, action) => {
            state.items = action.payload;
            state.last_fetched_at = Date.now();
            state.error = null;
            state.loading = false;
        })
        .addCase(fetchUserBrands.rejected, (state, action) => {
            state.error = action.payload ?? 'Failed to fetch user brands';
            state.loading = false;
        })
    }
})

export default userBrand.reducer;